import React, { useState } from "react";

const UNSET_GROUP_ID = "no_group_selected_hope_this_isnt_an_actual_group_id";
export const GroupContext = React.createContext();
export const GroupContextProvider = ({ children }) => {
  const [groupId, setGroup] = useState(UNSET_GROUP_ID);

  return <GroupContext.Provider value={{ groupId, setGroup }}>{children}</GroupContext.Provider>;
};
